export default __webpack_public_path__ + "static/media/Mystic's Straps of the Green Ones.ec3bcd3b.jpg";